var Shopify = Shopify || {};
let cartComponents = [];

const producardBtn = document.querySelectorAll('.productcard__atc');

document.addEventListener('DOMContentLoaded', function () {
  initializeCartComponents();

  // Initialize modal close button
  const modalCloseBtn = document.getElementById('modal-close');
  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeAddToCartModal();
    });
  }

  if (producardBtn) {
    producardBtn.forEach(function (atc) {
      atc.addEventListener('click', function (event) {
        event.preventDefault();
        const productQty = 1;
        const productId = atc.getAttribute('data-product-id');
        const productComparePrice = atc.getAttribute('data-product-compare-price');

        if (productId !== null) {
          const items = [
            {
              id: productId,
              quantity: parseInt(productQty, 10),
            },
          ];

          if (items) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ items: items }),
            })
              .then((response) => response.json())
              .then((data) => {
                showCartNotification(data, items, atc, productComparePrice);
                updateAllCartDropdowns();
                setTimeout(function () {
                  hideCartNotification();
                }, 3000);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }
        }
      });
    });
  }
});

function hideCartNotification() {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  cart_notification.forEach((cartNotification) => {
    cartNotification.classList.add('hidden');
    cartNotification.innerHTML = '';
  });
}

async function updateAllCartDropdowns() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    const cart = await response.json();

    // Update all cart counts across the page
    updateAllCartCounts(cart.item_count);

    // Update all cart dropdowns
    cartComponents.forEach((cartComponent) => {
      updateCartHTML(cartComponent.dropdown, cart);
    });

    return cart;
  } catch (error) {
    console.error('Error updating cart contents:', error);
  }
}

function updateAllCartCounts(count) {
  const cartCounts = document.querySelectorAll('.cart-count p');
  cartCounts.forEach((countElement) => {
    countElement.textContent = count;
  });
}

function updateCartHTML(dropdown, cart) {
  const cartItemsContainer = dropdown.querySelector('.cart-items');

  if (!cartItemsContainer) return;

  cartItemsContainer.innerHTML = '';

  if (cart.item_count === 0) {
    const cartFilled = dropdown.querySelector('.filled-cart');
    const cartItems = dropdown.querySelector('.cart-items');
    const cartTotals = dropdown.querySelector('.cart-totals');
    const cartActions = dropdown.querySelector('.cart-actions');

    if (cartFilled) cartFilled.style.display = 'none';
    if (cartItems) cartItems.style.display = 'none';
    if (cartTotals) cartTotals.style.display = 'none';
    if (cartActions) cartActions.style.display = 'none';

    const emptyCartDiv = dropdown.querySelector('.empty-cart');
    if (!emptyCartDiv) {
      const emptyCart = document.createElement('div');
      emptyCart.className = 'empty-cart text-center py-8';
      emptyCart.innerHTML = `
        <p class="text-lg mb-4">Je winkelwagen is leeg</p>
        <a href="/collections/all" class="inline-block bg-green-500 text-white font-bold py-3 px-6 rounded">
          Bekijk onze producten
        </a>
      `;
      cartItemsContainer.parentNode.appendChild(emptyCart);
    } else {
      emptyCartDiv.style.display = 'block';
    }
    return;
  }

  const emptyCartDiv = dropdown.querySelector('.empty-cart');
  if (emptyCartDiv) {
    emptyCartDiv.style.display = 'none';
  }

  const cartFilled = dropdown.querySelector('.filled-cart');
  const cartItems = dropdown.querySelector('.cart-items');
  const cartTotals = dropdown.querySelector('.cart-totals');
  const cartActions = dropdown.querySelector('.cart-actions');

  if (cartFilled) cartFilled.style.display = 'block';
  if (cartItems) cartItems.style.display = 'block';
  if (cartTotals) cartTotals.style.display = 'block';
  if (cartActions) cartActions.style.display = 'block';

  cart.items.forEach((item, index) => {
    const isLastItem = index === cart.items.length - 1;
    const cartItem = document.createElement('div');
    cartItem.className = `cart-item py-4 flex items-end gap-4 ${!isLastItem ? 'border-b border-gray-200' : ''}`;

    const price = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format(item.final_price / 100);

    cartItem.innerHTML = `
      <a href="${item.url}" class="flex-shrink-0 w-20">
        <img src="${item.image || '/assets/no-image.jpg'}" alt="${item.title}" class="w-full h-auto">
      </a>
      <div class="flex flex-col">
        <a href="${
          item.url
        }" class="text-base font-bold leading-tight mb-1 cart-item-title" style="white-space: wrap">${
      item.product_title
    }</a>
        ${
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="text-sm truncate" style="white-space: wrap">${item.variant_title}</p>`
            : ''
        }
        <p class="text-sm">Aantal: ${item.quantity}</p>
      </div>
      <div class="flex-shrink-0 text-right">
        <p>${price}</p>
      </div>
    `;

    cartItemsContainer.appendChild(cartItem);
  });

  const t = window.cartModalTranslations || {};
  const freeTxt = cart.total_price >= 5000 ? (t.shippingFree || 'Gratis') : (t.shippingAtCheckout || 'Berekend bij checkout');
  const totalsEl = dropdown.querySelector('.cart-totals');
  if (totalsEl) {
    const shippingEl = totalsEl.querySelector(':nth-child(1) p:last-child');
    if (shippingEl) {
      shippingEl.textContent = freeTxt;
      shippingEl.className = cart.total_price >= 5000 ? 'text-body font-bold text-green-500' : 'text-body font-bold';
    }

    const totalEl = totalsEl.querySelector(':nth-child(2) p:last-child');
    if (totalEl) {
      const totalPrice = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      }).format(cart.total_price / 100);

      totalEl.textContent = totalPrice;
    }
  }
}

function initializeCartComponents() {
  const allCartComponents = document.querySelectorAll('[data-component-id^="cart-component-"]');

  if (allCartComponents.length === 0) {
    console.log('No cart components found on page');
    return;
  }

  cartComponents = [];

  allCartComponents.forEach((component) => {
    const componentId = component.getAttribute('data-component-id');
    const index = componentId.split('-').pop();
    const toggleBtn = document.getElementById(`cartToggle-${index}`);
    const dropdown = document.getElementById(`cartDropdown-${index}`);
    const closeCart = document.getElementById(`close-cart-${index}`);
    const accountDropdown = document.querySelector('#accountDropdown');

    if (toggleBtn && dropdown) {
      cartComponents.push({
        component: component,
        dropdown: dropdown,
        index: index,
      });

      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log(`Cart ${componentId} toggle clicked`);

        updateAllCartDropdowns().then(() => {});
      });

      if (closeCart) {
        closeCart.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropdown.classList.remove('show');
          dropdown.classList.add('hidden');
        });
      }

      document.addEventListener('click', function (e) {
        if (!component.contains(e.target)) {
          dropdown.classList.remove('show');
          dropdown.classList.add('hidden');
        }
      });

      console.log(`Cart ${componentId} initialized`);
    }
  });

  updateAllCartDropdowns();
}

function showCartNotification(shoppingcart, added, product, comparePriceAtPrice) {
  const form = product.getAttribute('data-related-products');
  let relatedProductsData = [];

  if (form) {
    const relatedProductsAttr = form;
    if (relatedProductsAttr) {
      try {
        relatedProductsData = JSON.parse(relatedProductsAttr);
      } catch (e) {
        console.error('Error parsing related products:', e);
      }
    }
  }

  // Show the modal instead of notification
  showAddToCartModal(shoppingcart, added, relatedProductsData, comparePriceAtPrice);
}

function showAddToCartModal(shoppingcart, added, relatedProductsData, comparePriceAtPrice) {
  const modal = document.getElementById('add-to-cart-modal');
  const addedProductsContainer = document.getElementById('modal-added-products');
  const relatedProductsContainer = document.getElementById('modal-related-products');
  const relatedProductsMainContainer = document.getElementById('modal-related-products-container');

  // Get translations from window object
  const translations = window.cartModalTranslations || {
    added: 'Toegevoegd',
    continueShoppingText: 'Verder winkelen',
    goToCartText: 'Naar winkelwagen',
    directAvailable: 'Direct leverbaar',
    soldOut: 'Niet op voorraad',
    quantity: 'x',
    relatedTitle: 'Handig om mee te bestellen',
  };

  if (!modal) return;

  // Clear previous content
  addedProductsContainer.innerHTML = '';
  relatedProductsContainer.innerHTML = '';

  // Display added products
  const products = shoppingcart.items || [];
  const addedProducts = [];

  products.forEach((product) => {
    added.forEach((item) => {
      if (product.id == item.id) {
        addedProducts.push({
          ...product,
          quantity: item.quantity,
        });
      }
    });
  });

  // Render added products with translations
  addedProducts.forEach((product) => {
    const productEl = document.createElement('div');
    productEl.className = 'flex items-center gap-4';

    // Only show compare price if it exists and is different from current price
    let comparePrice = null;
    if (comparePriceAtPrice && comparePriceAtPrice > product.final_price) {
      comparePrice = '€' + (comparePriceAtPrice / 100).toFixed(2).replace('.', ',');
    }

    //let comparePrice = document.querySelector('#total-compare-price')?.innerHTML;

    // Format price with fallback
    let formattedPrice = '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      formattedPrice = Shopify.formatMoney(product.final_price, '{{amount_with_comma_separator}}');
    } else {
      formattedPrice = '€' + (product.final_price / 100).toFixed(2).replace('.', ',');
    }

    productEl.innerHTML = `
      <div class="flex flex-col md:flex-row md:items-center justify-between w-full">
        <div class="flex items-center gap-4 w-full">
          <img src="${product.image}" alt="${
      product.product_title
    }" style="width: 127px; height: 127px;" class="object-cover rounded-sm bg-soft">
          <div class="flex-1">
            <div class="flex items-center gap-1 mb-1">
              <div class="flex items-center justify-center">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8.03906" cy="8.51968" r="8" fill="#0A6E49"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 7.33324L3 8.49991L6.75 11.9999L13 6.16658L11.75 4.99991L6.75 9.66657L4.25 7.33324Z" fill="white"/>
                </svg>
              </div>
              <h2 class="text-sm text-accent">${translations.added}</h2>
            </div>
            <p class="text-h5 mb-1">${product.product_title}</p>
            <p class="text-sm text-gray-600 hidden">${product.quantity}${translations.quantity} ${formattedPrice}</p>
            <p class="text-sm text-gray-600">${
              comparePrice
                ? `<span class="line-through opacity-50" style="margin-right: 3px">${comparePrice}</span>`
                : ''
            } ${formattedPrice}</p>
          </div>
        </div>
        <div class="w-full md:w-auto md:ml-auto flex flex-col items-center sm:flex-row gap-1.5 md:gap-3 md:pr-6 pt-1 md:pt-0 pb-4 md:pb-0">
          <div class="flex items-center gap-2 mb-2 md:mb-0 pt-4 lg:pt-0">
            <label class="text-sm text-gray-600 sr-only">Quantity</label>
            <div class="flex items-center border border-gray-300 rounded-md">
              <button 
                type="button" 
                class="modal-quantity-decrease flex items-center justify-center px-3 text-gray-600 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                style="height: 38px"
                data-variant-key="${product.key}"
                aria-label="${translations.decreaseQuantity || 'Decrease quantity'}"
              >
                <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer-events-none">
                  <path d="M0 1H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
              <input 
                type="number" 
                class="modal-quantity-input w-12 text-center border-0 focus:outline-none focus:ring-0 text-sm"
                style="height: 38px; line-height: 38px; -moz-appearance: textfield;"
                value="${product.quantity}"
                min="1"
                data-variant-key="${product.key}"
                aria-label="${translations.quantityLabel || 'Quantity'}"
              />
              <button 
                type="button" 
                class="modal-quantity-increase flex items-center justify-center px-3 text-gray-600 hover:bg-gray-100 transition-colors"
                style="height: 38px"
                data-variant-key="${product.key}"
                aria-label="${translations.increaseQuantity || 'Increase quantity'}"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer-events-none">
                  <path d="M7 0V14M0 7H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
          </div>
          <div id="modal-actions" class="w-full md:w-auto flex flex-col items-center sm:flex-row gap-1.5 md:gap-3">
            <a href="" class="modal-continue flex-1 py-3 px-6 bg-white text-highlight_dark rounded-full underline transition-colors whitespace-nowrap flex items-center gap-2">
              <span>${translations.continueShoppingText}</span>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.519684" width="16" height="16" rx="8" fill="#EBE8E7"/>
                <path d="M12 8.51968L9.77778 10.5197M12 8.51968L9.77778 6.51968M12 8.51968H4" stroke="#332316" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
            <a href="${
              routes.cart_url
            }" class="flex-1 py-1 whitespace-nowrap pr-1 bg-accent text-white rounded-full hover:opacity-90 transition-opacity text-center flex items-center gap-2">
              <span style="padding-left: 24px">${translations.goToCartText}</span>
              <svg width="46" height="47" viewBox="0 0 46 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.519684" width="46" height="46" rx="23" fill="white" fill-opacity="0.1"/>
                <path d="M29.75 23.5197L26 27.2697M29.75 23.5197L26 19.7697M29.75 23.5197H16.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    `;
    addedProductsContainer.appendChild(productEl);

    // Add quantity selector functionality
    const quantityInput = productEl.querySelector(`.modal-quantity-input[data-variant-key="${product.key}"]`);
    const decreaseBtn = productEl.querySelector(`.modal-quantity-decrease[data-variant-key="${product.key}"]`);
    const increaseBtn = productEl.querySelector(`.modal-quantity-increase[data-variant-key="${product.key}"]`);

    // Decrease button handler
    decreaseBtn.addEventListener('click', function () {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        const newValue = currentValue - 1;
        quantityInput.value = newValue;
        updateCartQuantity(product.key, newValue);
      }
      updateButtonStates(quantityInput, decreaseBtn, increaseBtn);
    });

    // Increase button handler
    increaseBtn.addEventListener('click', function () {
      const currentValue = parseInt(quantityInput.value) || 1;
      const newValue = currentValue + 1;
      quantityInput.value = newValue;
      updateCartQuantity(product.key, newValue);
      updateButtonStates(quantityInput, decreaseBtn, increaseBtn);
    });

    // Input change handler
    quantityInput.addEventListener('change', function () {
      let value = parseInt(this.value) || 1;
      if (value < 1) value = 1;
      this.value = value;
      updateCartQuantity(product.key, value);
      updateButtonStates(quantityInput, decreaseBtn, increaseBtn);
    });

    // Update button states
    updateButtonStates(quantityInput, decreaseBtn, increaseBtn);
  });

  console.log('addedProductsContainer', addedProductsContainer);
  console.log('relatedProductsData', relatedProductsData);

  // Handle related products section
  if (relatedProductsData && relatedProductsData.length > 0) {
    // Show the container with title
    if (relatedProductsMainContainer) {
      relatedProductsMainContainer.style.display = 'block';
      // Update the title if needed
      const titleElement = relatedProductsMainContainer.querySelector('[data-modal-related-title]');
      if (titleElement && translations.relatedTitle) {
        titleElement.textContent = translations.relatedTitle;
      }
    }

    // Render related products with translations
    relatedProductsData.forEach((product) => {
      const productCard = document.createElement('div');
      productCard.className = 'related-product-card';

      // Get the first available variant
      const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
      if (!firstVariant) return;

      // Format the product URL
      const productUrl = `/products/${product.handle}`;

      // Get the featured image URL
      const imageUrl = product.featured_image || (product.images && product.images[0]) || '/assets/no-image.jpg';

      // Calculate discount if applicable
      let discountHtml = '';
      let priceHtml = '';

      // Format price with fallback
      let formattedPrice = '';
      let formattedComparePrice = '';

      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        formattedPrice = Shopify.formatMoney(firstVariant.price, '{{amount_with_comma_separator}}').replace('€', '');
        if (firstVariant.compare_at_price) {
          formattedComparePrice = Shopify.formatMoney(
            firstVariant.compare_at_price,
            '{{amount_with_comma_separator}}'
          ).replace('€', '');
        }
      } else {
        formattedPrice = (firstVariant.price / 100).toFixed(2).replace('.', ',');
        if (firstVariant.compare_at_price) {
          formattedComparePrice = (firstVariant.compare_at_price / 100).toFixed(2).replace('.', ',');
        }
      }

      if (firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price) {
        const discountAmount = firstVariant.compare_at_price - firstVariant.price;
        const discountPercentage = Math.round((discountAmount / firstVariant.compare_at_price) * 100);

        if (discountPercentage > 0) {
          discountHtml = `
            <div class="absolute top-3 left-4 bg-highlight_light text-[#332316] font-regular text-h5 px-3 py-0.5 rounded-full z-10">
              -${discountPercentage}%
            </div>
          `;
        }

        priceHtml = `
          <div class="flex gap-2 items-center lg:mt-auto">
            <p class="text-md text-dull line-through">
              ${formattedComparePrice}
            </p>
            <div class="flex items-center gap-[10px] text-base text-highlight_dark font-bold">
              <p class="text-h5 text-highlight_dark font-semibold">
                ${formattedPrice}
              </p>
            </div>
          </div>
        `;
      } else {
        priceHtml = `
          <div class="flex items-center gap-[10px] text-base text-highlight_dark font-bold">
            <p class="text-h5 text-highlight_dark font-semibold">
              ${formattedPrice}
            </p>
          </div>
        `;
      }

      // Check availability with translations
      const availabilityHtml = firstVariant.available
        ? `<div class="text-[11px] text-accent space-x-2 flex items-start mt-0 mb-0.5">
          <p class="block">${translations.directAvailable}</p>
        </div>`
        : `<div class="text-[11px] text-red-500 space-x-2 flex items-start mt-0">
          <p class="block">${translations.soldOut}</p>
        </div>`;

      productCard.innerHTML = `
        <a href="${productUrl}" title="${product.title}" class="relative flex flex-col group cursor-pointer transition h-full">
          <div class="flex flex-col gap-3 flex-grow items-center md:items-start rounded-lg">
            <div class="relative flex justify-center w-full bg-soft">
              <img
                src="${imageUrl}"
                alt="${product.title}"
                height="304"
                loading="lazy"
                class="w-full bg-bright object-cover rounded-[3px] w-full aspect-[1/1]"
              >
              <button 
                class="add-to-cart-quick absolute bottom-3 right-3 hover:opacity-90 transition-opacity"
                data-variant-id="${firstVariant.id}"
                data-product-title="${product.title}"
                data-product-price="${firstVariant.price}"
              >
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="42" height="42" rx="21" fill="#0A6E49"/>
                  <path d="M15 21H21M21 21H27M21 21V27M21 21V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            
            ${discountHtml}
            
            <div class="flex flex-col md:pl-0 py-[10px] lg:px-3 lg:pt-3 lg:pb-1 w-full">
              ${availabilityHtml}
              <p class="text-highlight_dark text-[16px] md:text-h5 leading-normal font-primary mt-1 mb-0 md:mb-0">
                ${product.title}
              </p>
              <div class="md:hidden">
                ${priceHtml}
              </div>
            </div>
          </div>
          
          <div class="hidden md:block px-[10px] pb-[10px] lg:px-3 lg:pb-3">
            ${priceHtml}
          </div>
        </a>
      `;

      // Add quick add to cart functionality
      const quickAddBtn = productCard.querySelector('.add-to-cart-quick');
      quickAddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = this.getAttribute('data-variant-id');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Update cart count
            updateAllCartDropdowns();

            // Show success feedback
            this.innerHTML = `
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="42" height="42" rx="21" fill="#0A6E49"/>
              <path d="M13 21L18.3337 26L29 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;

            // setTimeout(() => {
            //   this.innerHTML = `
            //   <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            //     <rect width="42" height="42" rx="21" fill="#0A6E49"></rect>
            //     <path d="M15 21H21M21 21H27M21 21V27M21 21V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            //   </svg>
            // `;
            // }, 2000);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
          });
      });

      relatedProductsContainer.appendChild(productCard);
    });
  } else {
    // Hide the entire container including title when no related products
    if (relatedProductsMainContainer) {
      relatedProductsMainContainer.style.display = 'none';
    }
  }

  // Show modal
  modal.classList.remove('hidden');
  modal.style.display = 'block';
  console.log('modal.style.display', modal.style.display);
  document.body.style.overflow = 'hidden';

  // Trigger animation
  setTimeout(() => {
    modal.classList.add('active');
  }, 10);

  // Update all cart dropdowns
  updateAllCartDropdowns();
}

async function updateCartQuantity(variantKey, quantity) {
  try {
    // Update the cart
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [variantKey]: quantity,
        },
      }),
    });

    if (!updateResponse.ok) {
      throw new Error('Failed to update cart');
    }

    // Update cart dropdowns
    updateAllCartDropdowns();
  } catch (error) {
    console.error('Error updating cart quantity:', error);
  }
}

// Helper function to update button states
function updateButtonStates(quantityInput, decreaseBtn, increaseBtn) {
  const value = parseInt(quantityInput.value) || 1;

  // Disable decrease button if quantity is 1
  if (value <= 1) {
    decreaseBtn.disabled = true;
    decreaseBtn.classList.add('opacity-50', 'cursor-not-allowed');
  } else {
    decreaseBtn.disabled = false;
    decreaseBtn.classList.remove('opacity-50', 'cursor-not-allowed');
  }
}

// Function to close the add to cart modal
function closeAddToCartModal() {
  const modal = document.getElementById('add-to-cart-modal');

  if (!modal) return;

  // Remove active class for animation
  modal.classList.remove('active');

  // Hide modal after animation
  setTimeout(() => {
    modal.classList.add('hidden');
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }, 300); // Adjust timing to match your CSS transition duration
}
